module.exports = __webpack_public_path__ + "static/media/original_strawberry.cf0c3187.png";